import { FINISHED } from "./constants";
import {
  COACHING_STYLE,
  END_POINTS_BRANCH,
  END_DIABETES_BRANCH,
  END_CLINICAL_BRANCH,
  END_GLP1_BRANCH,
  PAST_ED_DIAGNOSIS,
  PREGNANCY,
  PHQ9B,
  SUICIDE1A
} from "../../config/tags";
import {
  POINTS_WORKSHOP_PROGRAM,
  POINTS_PROGRAM,
  DIABETES_WORKSHOP_PROGRAM,
  DIABETES_PROGRAM,
  GLP1_PROGRAM,
  CLINICAL_PROGRAM,
  NOT_ELIGIBLE_BULEMIA,
  NOT_ELIGIBLE_PREGNANCY,
  NOT_ELIGIBLE_MENTAL_HEALTH
} from "./constants";

const uniIsPremium = (answers, questions) => {
  const premiumQuestion = questions
    .filter(question => question.tags.includes(COACHING_STYLE))
    .map(q => q?._id);
  const answer = answers.find(answer =>
    premiumQuestion.includes(answer.questionId)
  );

  return !!answer;
};

export const getResultsPageUni = (answers, questions) => {
  const lastAnswer = answers[answers.length - 1];
  const idLastQuestionAsked = lastAnswer.questionId;

  // Last question tags.
  const tags = questions.find(
    question => question._id === idLastQuestionAsked
  ).tags;

  const isPremium = uniIsPremium(answers, questions);

  if (tags.includes(END_POINTS_BRANCH)) {
    if (isPremium) {
      return POINTS_WORKSHOP_PROGRAM;
    } else {
      return POINTS_PROGRAM;
    }
  } else if (tags.includes(END_DIABETES_BRANCH)) {
    if (isPremium) {
      return DIABETES_WORKSHOP_PROGRAM;
    } else {
      return DIABETES_PROGRAM;
    }
  } else if (tags.includes(END_GLP1_BRANCH)) {
    return GLP1_PROGRAM;
  } else if (tags.includes(END_CLINICAL_BRANCH)) {
    return CLINICAL_PROGRAM;
  } else if (tags.includes(PAST_ED_DIAGNOSIS)) {
    return NOT_ELIGIBLE_BULEMIA;
  } else if (tags.includes(PREGNANCY)) {
    return NOT_ELIGIBLE_PREGNANCY;
  } else if (tags.includes(PHQ9B) || tags.includes(SUICIDE1A)) {
    return NOT_ELIGIBLE_MENTAL_HEALTH;
  }

  // We should never reach this point.
  return null;
};

export const getIsClinicEligibileUni = (answers, questions) => {
  if (getResultsPageUni(answers, questions) === CLINICAL_PROGRAM) {
    return true;
  }

  return false;
};

export const resultsFunction = () => FINISHED;
